function requestAPI(token) {
  return fetch(`${process.env.REACT_APP_AGENT_URL}referral-code`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionGetReferralCode(token) {
  return async (dispatch) => {
    const existingReferral = localStorage.getItem('referral')
    if (existingReferral) {
      return existingReferral
    }

    const authToken = token || localStorage.getItem('nabawi-token')
    if (!authToken) return

    dispatch({
      type: 'GET_REFERRAL_CODE_BEGIN'
    })

    try {
      const result = await requestAPI(authToken)
      if (!result.status) {
        handleErrors(dispatch, result)
        return
      }

      const code = typeof result.data === 'string' ? result.data : (result.data ? (result.data.referral || result.data.referral_code) : null)
      if (code) {
        localStorage.setItem('referral', code)
      }

      dispatch({
        type: 'GET_REFERRAL_CODE_SUCCESS',
        referral: code
      })

      return code
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({
    type: 'GET_REFERRAL_CODE_FAILURE',
    error: error
  })
}
